"use strict";

const Floorplan = () => {
    const init = () => {
        $(function() {
            var $floorplans = $('.js-floorplan-simple');
            if($floorplans.length){
                $floorplans.each(function(){
                    var $floorplan = $(this);
                    var $floorplanImages = $floorplan.find('.js-floorplan-image');
                    var $levels = $floorplan.find('.js-floorplan-level');
                    var $floorplanOptions = $floorplan.data('floorplan-options');
                    
                    if($levels.length){
                        var level = $levels.filter('.active').data('level');
                        var $floorplanImage = $floorplanImages.filter('[data-level="'+level+'"]');
                    }else{
                        var $floorplanImage = $floorplanImages;
                    }
                    $floorplanImage.addClass('active');
                    $floorplanImages.find('.image').html('');
                    inlineSVG($floorplanImage);
                    
                    function inlineSVG($this){
                        var $svg = $(JSON.parse($this.find('.image').data('svg')));
                        $svg.children('g').each(function(){
                            $(this).attr('data-id', $(this).attr('id'));
                        });
                        $this.find('.image').append($svg);
                        $.each($floorplanOptions, function(k,v){
                            $svg.find('g[data-id$="'+v+'"]').show();
                        });
                    }
                    
                    $levels.on('click', function(){
                        $levels.removeClass('active');
                        $(this).addClass('active');
                        $floorplanImages.removeClass('active');
                        var $floorplanImage = $floorplanImages.filter('[data-level="'+$(this).data('level')+'"]');
                        $floorplanImage.addClass('active');
                        $floorplanImages.find('.image').html('');
                        inlineSVG($floorplanImage);
                    });
                })
            }
        });
    };
    
    return {
        init:init
    };
};

export default Floorplan;